// src/components/Dropdown.js
import styled from 'styled-components';

const DropdownWrapper = styled.div`
  margin: 10px 0;
  width: 100%;
`;

const Label = styled.label`
  display: block;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text};
  margin-bottom: 5px;
`;

const Select = styled.select`
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 14px;
`;

function Dropdown({ label, options, value, onChange }) {
  return (
    <DropdownWrapper>
      <Label>{label}</Label>
      <Select value={value} onChange={(e) => onChange(e.target.value)}>
        <option value="">vælg venligst...</option>
        {options.map((option, index) => (
          <option key={index} value={option}>
            {option}
          </option>
        ))}
      </Select>
    </DropdownWrapper>
  );
}

export default Dropdown;
